import React from 'react'
import Header from './Header'
import "./Home.css"
import TypeAnimation from 'react-type-animation';
import About from './About';
import Projects from "./Projects"
import Contact from './Contact';
import Skills from "./Skills"
import Experience from  "./Experience"
import imgPotfolio from "./images/profile-1.JPG"
import Particles from "react-tsparticles";
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import Footer from './Footer';

const Home = () => {

    const particlesInit = (main) => {
        console.log(main);
    
        // you can initialize the tsParticles instance (main) here, adding custom shapes or presets
      };
    
      const particlesLoaded = (container) => {
        console.log(container);
      };

    const ExampleComponent = () => {
        return (
          <TypeAnimation
            cursor={false}
            sequence={['React typing animation based on typical', 1000, '']}
            wrapper="h2"
          />
        );
      };

  return (
    <div>
        <div>
            <Header />
        </div>
        {
            /*<div className="up">
            <ArrowUpwardIcon className="up__home"/>
        </div>*/ 
        }
        

            
        <div className="home">
            {/*
        <Particles
            className="partilcles"
            id="tsparticles"
            init={particlesInit}
            loaded={particlesLoaded}
            options={{
        
                fpsLimit: 120,
                interactivity: {
                events: {
                    onClick: {
                    enable: true,
                    mode: "push",
                    },
                    onHover: {
                    enable: true,
                    mode: "repulse",
                    },
                    resize: true,
                },
                modes: {
                    bubble: {
                    distance: 400,
                    duration: 2,
                    opacity: 0.8,
                    size: 40,
                    },
                    push: {
                    quantity: 4,
                    },
                    repulse: {
                    distance: 200,
                    duration: 0.9,
                    },
                },
                },
                particles: {
                color: {
                    value: "#ffffff",
                },
                links: {
                    color: "#ffffff",
                    distance: 150,
                    enable: true,
                    opacity: 0.5,
                    width: 1,
                },
                collisions: {
                    enable: true,
                },
                move: {
                    direction: "none",
                    enable: true,
                    outMode: "bounce",
                    random: false,
                    speed: 6,
                    straight: false,
                },
                number: {
                    density: {
                    enable: true,
                    area: 800,
                    },
                    value: 80,
                },
                opacity: {
                    value: 0.5,
                },
                shape: {
                    type: "circle",
                },
                size: {
                    random: true,
                    value: 5,
                },
                },
                detectRetina: true,
            }}
            />
        */}
            <div className="home__img1">
                <img src={imgPotfolio} alt="" />
            </div>
            <div className="intro_text">
                <p className="intro">
                    Hello, my name is
                </p>
                <h1 className="name">
                    Edward Ndlovu
                </h1>
                <p className="work_intro">
                    And I'm a <span className="typing">{ExampleComponent}</span>
                    <div className="typing"  >
                        <TypeAnimation
                        cursor={true}
                        sequence={[
                        'YouTuber',
                            2000,
                        'Developer.',
                            2000,
                        'Designer',
                            2000,
                        'Freelancer',
                            2000
                        ]}
                        wrapper="h2"
                        repeat={Infinity}
                        />
                    </div>
                </p>
            </div>

            <div className="home__img2">
                <img src={imgPotfolio} alt="" />
            </div>
        </div>

        <a id="about">
            <About />
        </a>
        
        <a id="projects">
            <Projects />
        </a>
        
        <a id="skills">
            <Skills />
        </a>
        
        {
            /*
                <a id="skill">
            <Experience />  
        </a>
             */
        }
        
        
        <a id="contact">
            <Contact />
        </a>
        <Footer />
        

    
    </div>
  )
}

export default Home